import { Card, CardContent, Chip, Divider, Stack, Typography } from '@mui/material'

export function formatQuota(quota) {
	if (quota.mode === 'unlimited') return `${quota.usage} использовано · без лимита`
	return `${quota.usage} из ${quota.limit} · осталось ${quota.remaining}`
}

const LABELS = {
	team_members_active: 'Активные участники агентства',
	objects_active: 'Активные объекты',
	requests_active: 'Активные заявки',
}

const SubscriptionInfo = ({ entitlements }) => {
	const basePlan = entitlements.access.basePlan
	const subscription = entitlements.subscription
	return (
		<Card className='mb-6 shadow-md'>
			<CardContent>
				<Stack direction='row' justifyContent='space-between' alignItems='center' mb={2}>
					<Typography variant='h5'>Текущий доступ</Typography>
					<Chip label={basePlan.name} color='primary' variant='outlined' />
				</Stack>
				<Typography variant='body2' color='text.secondary'>
					Источник базового доступа: {entitlements.access.source}
				</Typography>
				<Typography variant='body2' color='text.secondary'>
					{subscription
						? `Состояние подписки: ${subscription.state}${subscription.endsAt ? ` · до ${new Date(subscription.endsAt).toLocaleDateString('ru-RU')}` : ''}`
						: 'Базовая подписка отсутствует; применяется fallback-план'}
				</Typography>
				<Stack direction='row' spacing={1} mt={2} useFlexGap flexWrap='wrap'>
					{entitlements.packages.map((item, index) => (
						<Chip
							key={`${item.code}-${item.source}-${index}`}
							size='small'
							label={`${item.name} · ${item.source}`}
						/>
					))}
				</Stack>
				<Divider sx={{ my: 2 }} />
				<Stack spacing={1}>
					{Object.entries(entitlements.limits).map(([key, quota]) => (
						<Typography key={key} variant='body1'>
							{LABELS[key] || key}: {formatQuota(quota)}
						</Typography>
					))}
				</Stack>
			</CardContent>
		</Card>
	)
}

export default SubscriptionInfo
